import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCa from '@worktango/translations/survey/en-ca.json';
import frCa from '@worktango/translations/survey/fr-ca.json';

const options = {
  // order from where user language should be detected
  order: ['navigator', 'querystring', 'cookie', 'localStorage', 'htmlTag', 'path', 'subdomain'],
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: options,
    fallbackLng: 'enCa',
    ns: ['translations'],
    defaultNS: 'translations',
    debug: false,
    resources: {
      enCa: enCa,
      frCa: frCa,
    },
    lng: 'enCa',
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
      format: (value, format, _lng) => {
        if (format === 'uppercase') return value.toUpperCase();
        return value;
      },
    },
  });

export default i18n;
